import CIMSLink from 'components/CIMSLink'
import { SharePointResource } from 'schema'

const PacketLink: React.FC<
  Partial<Pick<SharePointResource, 'webUrl' | 'name'>>
> = ({ name, webUrl }) => {
  if (!webUrl) return null
  return (
    <CIMSLink external href={webUrl}>
      {name ?? 'Packet'}
    </CIMSLink>
  )
}

export default PacketLink
